export default {
  SET_LISTA (state, lista) {
    if (state.paginaAtual === 1) {
      state.lista = lista
      return
    }

    state.lista = state.lista.concat(lista)
  },

  SET_TOTAL_ITENS (state, totalItens) {
    state.totalItens = totalItens
    state.todosItensCarregados = Array.isArray(state.lista) ? state.totalItens <= state.lista.length : false;
  },

  SET_PAGINA_ATUAL (state, pagina) {
    state.paginaAtual = pagina
  },

  INCREMENTAR_PAGINA_ATUAL (state) {
    state.paginaAtual++
  },

  SET_ESTA_CARREGANDO (state, value) {
    state.estaCarregando = value
  },

  SET_ITEM_SELECIONADO_ID (state, value) {
    state.itemSelecionadoID = value
  },

  SET_ITEM_SELECIONADO (state, value) {
    state.itemSelecionado = value
  },

  LIMPAR_ITEM_SELECIONADO (state) {
    state.itemSelecionadoID = null
    state.itemSelecionado = {
      id: null,
      sistema_avaliacao: null,
      idioma: null,
      curso: null,
      item: null,
      planejamento_licao: null,
      proximo_livro: null,
      idade_minima: null,
      maximo_alunos: null,
      numero_aulas: 0,
      situacao: null,
      descricao: null
    }
  },

  SET_FILTROS_DESCRICAO (state, value) {
    state.filtros.descricao = value
  },

  SET_FILTROS_CURSO (state, value) {
    state.filtros.curso = value
  },

  SET_FILTROS_IDIOMA (state, value) {
    state.filtros.idioma = value
  },

  SET_ORDER_BY (state, value) {
    state.order = value.order
    state.direcao = value.direcao
  }

}
